import BundesligaLogo from '../../../assets/BLLogo.png';
import SerieALogo from '../../../assets/SerieA.png';
import CLLogo from '../../../assets/CLLogo.png';
import ELLogo from '../../../assets/EuroLeague.png';
import PLLogo from '../../../assets/PremierLeagueLogo.png';
import LaLigaLogo from '../../../assets/LaLigaLogo.png';
export const POPULAR_TEAMS = [
  'Manchester City',
  'Real Madrid',
  'FC Barcelona',
  'Inter Mailand',
  'Liverpool FC',
  'Arsenal FC',
  'Bayer Leverkusen',
  'Sporting Lissabon',
  'Bayern München',
  'Paris Saint-Germain',
  'Atalanta BC',
  'Borussia Dortmund',
  'Atlético Madrid',
  'RB Leipzig',
  'FC Porto',
  'Juventus Turin',
  'AC Mailand',
  'Fenerbahce Istanbul',
  'Eintracht Frankfurt',
  'VfB Stuttgart',
  'FC Chelsea',
  'PSV Eindhoven',
];

export const SHOWN_COMPETITIONS = [
  { name: 'Bundesliga 24/25', logo: BundesligaLogo },
  { name: 'UEFA Champions League 24/25', logo: CLLogo },
  { name: 'Premier League 24/25', logo: PLLogo },
  { name: 'LaLiga 24/25', logo: LaLigaLogo },
  { name: 'Serie A 24/25', logo: SerieALogo },
  { name: 'UEFA Europa League 24/25', logo: ELLogo },
];
export const MAX_AMOUNT = 30;
